module.exports = __webpack_public_path__ + "static/media/17.4e4977b9.jpg";